import React, { Component } from 'react'
import defultBcg from '../images/room-1.jpeg'
import Hero from '../component/Hero'
import Banner from '../component/Banner'
import { Link } from 'react-router-dom'
import {RoomContext} from '../context'
import StyleHero from '../component/StyledHero'


export default class SingelRoom extends Component {
    constructor(props){
        super(props)
        //console.log(this.props);
        this.state={
            slug: this.props.match.params.slug,defultBcg
        }
    }  
    static contextType = RoomContext; 
  //componentDidMount(){}
    render() {
        const {getRoom} = this.context;
        const room = getRoom(this.state.slug);
        if(!room){
            return <div className="error">
                <h3>no such room could be found...</h3>
                <Link to="/rooms" className="btn-primary">back to rooms</Link>
            </div>
        }
        const {name,description,capacity,size,price,extras,breakfast,pets,images}= room
        const [mainImg,...defultImg]=images;

        return (
            <>
            <StyleHero img={mainImg || this.state.defultBcg}>
                <Banner title={`${name} room`} >
                <Link to="/rooms" className="btn-primary">back to rooms</Link>
                </Banner>
            </StyleHero>
            <section className="single-room">
                <div className="single-room-images">
                    {defultImg.map((item,index)=>{
                       return <img key={index} src={item} alt={name} />
                    })}
                </div>
                <div className="single-room-info">
                    <article className="desc">
                        <h3>details</h3>
                        <p>{description}</p>
                    </article>
                    <article className="info">
                        <h3>info</h3>
                        <h6>price : ${price}</h6>
                        <h6>size : {size} SQFT</h6>
                        <h6>max capacity : {""} {capacity >1? `${capacity} person`: `${capacity} person`}</h6>
                        <h6>{pets? "pets allowed": "no pets allowed"}</h6>
                        <h6>{breakfast && "free breakfast included"}</h6>
                    </article>
                </div>
            </section>
            <section className="room-extras">
                <h6>extras</h6>
                    <ul className="extras">
                        {extras.map((item, index)=>{
                            return <li key={index}>- {item}</li>;
                        })}
                    </ul>
            </section>
            </>
        )
    }
}
